import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { ManagementLoginAttemptSearchModel } from '@data-layer/models/management';
import { LoginAttemptModel, PaginatedResultModel } from '@data-layer/models/common';

@Injectable({
  providedIn: 'root',
})
export class LoginAttemptsRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params: ManagementLoginAttemptSearchModel,
    isShowLoader: boolean = true,
  ): Observable<PaginatedResultModel<LoginAttemptModel>> {
    return this.apiService.get<PaginatedResultModel<LoginAttemptModel>>(
      `${environment.url.prefixCustoms + 'v2/management/login-attempts'}`,
      { params },
      { isShowLoader },
    );
  }

  public getUserLoginAttempts(
    offset: number = 0,
    limit: number = null,
    isShowLoader: boolean = true,
  ): Observable<PaginatedResultModel<LoginAttemptModel>> {
    return this.apiService.get<PaginatedResultModel<LoginAttemptModel>>(
      `${environment.url.prefixCustoms + 'v2/login-attempts'}`,
      {
        params: { limit, offset },
      },
      { isShowLoader },
    );
  }
}
